import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { fetchCatalogsIfNeeded } from '@/redux/modules/catalog/catalogs/catalog.actions';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Loading } from '@liveauctioneers/hammer-ui-core/loading';
import { useAppDispatch } from '@/redux/hooks';
import { useEffect, useState } from 'react';
import AuctionsNearMeFilterBar from './components/FilterBar/AuctionsNearMeFilterBar';
import CatalogGrid from '@/components/CatalogCard/CatalogGrid';
import Pagination from '@/components/Pagination/hammer-pagination/Pagination';

export type Props = {
    catalogIds: number[];
    currentPage: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (pageSize: number) => void;
    pageSize: number;
    totalRecords: number;
};

export const AuctionsNearMeCardsViewNew = ({
    catalogIds,
    currentPage,
    onPageChange,
    onPageSizeChange,
    pageSize,
    totalRecords,
}: Props) => {
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(!catalogIds || catalogIds.length === 0);

    useEffect(() => {
        if (catalogIds.length > 0) {
            setIsLoading(false);
            dispatch(fetchCatalogsIfNeeded({ catalogIds }));
        }
    }, [dispatch, catalogIds]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentPage]);

    const handlePaginationChange = ({ page, pageSize: newPageSize }: { page: number; pageSize?: number }) => {
        if (page !== currentPage) {
            onPageChange(page);
        }
        if (newPageSize && newPageSize !== pageSize) {
            onPageSizeChange(newPageSize);
        }
    };

    const catalogsView = (
        <section className="mx-[-10px] my-0 w-[calc(100%+20px)] max-w-[calc(100%+20px)] shrink-0 grow basis-auto">
            <Pagination
                onChange={handlePaginationChange}
                pageSizeOptions={[24, 48, 72, 96, 120]}
                paginationFilter={{
                    page: currentPage,
                    pageSize: pageSize,
                    totalRecords: totalRecords,
                }}
                shouldModifyQueryParams
            >
                <CatalogGrid catalogIds={catalogIds} />
            </Pagination>
        </section>
    );

    const noCatalogsView = (
        <section>
            <BodyPrimary>
                <FormattedMessage id="no_auctions_available_in_area" />
            </BodyPrimary>
        </section>
    );

    const results = catalogIds.length > 0 ? catalogsView : noCatalogsView;

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div>
                    <div className="tabletMin:sticky tabletMin:top-0 tabletMin:z-[11] tabletMin:bg-background-primary tabletMin:pb-sm tabletMin:pt-lg">
                        {/* TODO: Add filter functionality. Will be done as part of next ticket: SG-327 */}
                        <AuctionsNearMeFilterBar
                            numberOfAuctions={catalogIds.length > 0 ? totalRecords : 0}
                            onKeywordsChange={() => {}}
                            toggleLocalPickUpFilter={() => {}}
                            toggleTopRatedFilter={() => {}}
                        />
                    </div>
                    {results}
                </div>
            )}
        </>
    );
};
